/**
 *
 * Styles for TeaserBusinessAssistant
 *
 */

import styled from "styled-components";
import { DhlText } from "@dhl-official/react-library";
import { Headline } from "root/libs/ui-components/src";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const CardWrapper = styled.div`
  padding: var(--dui-size-space-20x);
  text-align: center;

  svg {
    width: 100px;
    margin-bottom: var(--dui-size-space-10x);

    @media screen and (min-width: ${breakpoints.tablet}) {
      width: 180px;
      margin: 0 var(--dui-size-space-12x) 0 0;
    }
  }

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: var(--gaq-size-space-70px) var(--dui-size-space-40x)
      var(--gaq-size-space-90px);
    display: flex;
    align-items: flex-start;
    text-align: left;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding: var(--dui-size-space-40x) var(--gaq-size-space-120px)
      var(--dui-size-space-50x);
  }
`;

export const ContentWrapper = styled.div`
  display: block;
`;

export const StyledHeadline = styled(Headline)`
  margin-bottom: var(--dui-size-space-7x);
`;

export const StyledText = styled(DhlText)`
  & > *:is(p, span) {
    display: block;
    margin-bottom: var(--dui-size-space-7x);
  }
`;
